<template>
  <div id="app">
    <ArtworkForm />
  </div>
</template>

<script>
import ArtworkForm from '../components/ArtworkForm.vue'

export default {
  name: 'edit',
  mounted() {
    const { postId } = this.$route.params
    this.$store.dispatch('setEditPost', { postId } )
  },
  components: {
    ArtworkForm
  }
}
</script>

<style>
</style>
